// extracted by mini-css-extract-plugin
export default {"customBtn":"NavBar_customBtn__AI82D","wrapperIcon":"NavBar_wrapperIcon__gU7kY","navLink":"NavBar_navLink__pasUE"};